// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordion_root__2l4cv","accordion":"Accordion_accordion__1hFns","arrow":"Accordion_arrow__3QYNk","panel":"Accordion_panel__9c7Zo"};